var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-row",
    [
      _c("b-col", [
        _c(
          "div",
          { staticClass: "all-product-cards" },
          [
            _vm._l(_vm.sortedProducts, function (allGroupProducts, index) {
              return [
                _c(
                  "h2",
                  {
                    key: `grouping-label-${index}`,
                    staticClass: "product-heading",
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.getGroupByLabel(allGroupProducts)) +
                        "\n        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    key: `grouping-cards-${index}`,
                    staticClass: "product-cards",
                  },
                  _vm._l(
                    allGroupProducts.sortedProducts,
                    function (product, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "product-card" },
                        [
                          _vm.hasSettings(product)
                            ? _c("div", { staticClass: "settings-icon" }, [
                                _c(
                                  "button",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.showSubstituteLightBox(
                                          product
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      staticClass: "icon",
                                      attrs: {
                                        icon: ["fa", "ellipsis-vertical"],
                                        size: "1x",
                                        "fixed-width": "",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "product-image" },
                            [
                              _c("AImage", {
                                attrs: {
                                  img: _vm.getFirstImage(product),
                                  ratio: "3-4",
                                  preset: "wineproductteaser",
                                  contain: "",
                                },
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.showDetails(product)
                                  },
                                },
                              }),
                              _vm._v(" "),
                              product.awardWinner
                                ? _c("div", { staticClass: "award-winner" }, [
                                    _vm._v(
                                      "\n                Award Winner\n              "
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "details-icon" },
                                [_c("details-icon")],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "product-info" }, [
                            _c("div", { staticClass: "product-title" }, [
                              _c("h3", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("formatEntities")(product.title)
                                  )
                                ),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _vm.showPrice(product)
                            ? _c(
                                "div",
                                { staticClass: "pricing" },
                                [
                                  _vm.priceDifferent(product)
                                    ? _c(
                                        "div",
                                        { staticClass: "price sale-price" },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(_vm.price(product)) +
                                              "\n              "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "price club-price" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.discountedPrice(product)) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("product-debug-info", {
                                    attrs: { product: product },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "quantity-container",
                              class: {
                                "show-selector": _vm.getQuantity(product) > 0,
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "quantity-container-inner" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "quantity-selector" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "btn btn-primary decrement",
                                          on: {
                                            click: function ($event) {
                                              return _vm.decrement(product)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    -\n                  "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "quantity-input" },
                                        [
                                          _c("b-input", {
                                            key: _vm.quantityInputKey,
                                            attrs: {
                                              value: _vm.getQuantity(product),
                                              min: "0",
                                              step: "1",
                                              type: "number",
                                              "data-cy": "bottle-qty",
                                            },
                                            on: {
                                              input: (val) =>
                                                _vm.setQuantity(product, val),
                                            },
                                            nativeOn: {
                                              keypress: function ($event) {
                                                return _vm.keyPress.apply(
                                                  null,
                                                  arguments
                                                )
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "btn btn-primary increment",
                                          class: {
                                            disabled: _vm.maxReached(product),
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.increment(product)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    +\n                  "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.onRequest(product) &&
                                  !_vm.hasDefaultSelection(product)
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "btn btn-primary on-request",
                                          attrs: { "data-cy": "on-request" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.makeRequest(product)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  On Request\n                "
                                          ),
                                        ]
                                      )
                                    : _c(
                                        "div",
                                        {
                                          staticClass:
                                            "btn btn-primary add-to-order",
                                          class: {
                                            disabled: _vm.maxReached(product),
                                          },
                                          attrs: { "data-cy": "add-to-order" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.increment(product)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  Add To Order\n                "
                                          ),
                                        ]
                                      ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("transition", { attrs: { name: "move-in" } }, [
                            _vm.productMaxReached(product)
                              ? _c(
                                  "div",
                                  { staticClass: "product-max-reached" },
                                  [
                                    _vm._v(
                                      "\n                The maximum quantity for this product has been reached.\n              "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _c("transition", { attrs: { name: "move-in" } }, [
                            !_vm.productMaxReached(product) &&
                            !_vm.isVisible(product)
                              ? _c(
                                  "div",
                                  { staticClass: "product-not-readdable" },
                                  [
                                    _vm._v(
                                      "\n                You have reduced the quantity of a limited product. If you save your order, you will not be able to add more of this product.\n              "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                        ],
                        1
                      )
                    }
                  ),
                  0
                ),
              ]
            }),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _c(
        "AModal",
        {
          attrs: { actions: _vm.lightboxActions },
          on: {
            modalhidden: function ($event) {
              return _vm.$emit("modalToggled")
            },
          },
          model: {
            value: _vm.showLightbox,
            callback: function ($$v) {
              _vm.showLightbox = $$v
            },
            expression: "showLightbox",
          },
        },
        [
          _vm.lightboxProduct
            ? _c("div", { staticClass: "lightbox-product-details" }, [
                _c("div", { staticClass: "lightbox-product-title" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm._f("formatEntities")(_vm.lightboxProduct.title)
                      ) +
                      "\n      "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "lightbox-product-image" },
                  [
                    _vm.currentLightboxImage
                      ? _c("AImage", {
                          attrs: { img: _vm.currentLightboxImage, contain: "" },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "pricing" }, [
                  _vm.priceDifferent(_vm.lightboxProduct)
                    ? _c(
                        "div",
                        {
                          staticClass: "price sale-price",
                          attrs: { title: "Sale Price" },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.price(_vm.lightboxProduct)) +
                              "\n        "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "price club-price",
                      attrs: { title: "Club Price" },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.discountedPrice(_vm.lightboxProduct)) +
                          "\n        "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", {
                  staticClass: "lightbox-product-description",
                  domProps: { innerHTML: _vm._s(_vm.lightboxProduct.abstract) },
                }),
              ])
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c(
        "AModal",
        {
          attrs: { actions: _vm.substituteLightboxActions },
          on: {
            modalhidden: function ($event) {
              return _vm.$emit("modalToggled")
            },
          },
          model: {
            value: _vm.showSubstituteLightbox,
            callback: function ($$v) {
              _vm.showSubstituteLightbox = $$v
            },
            expression: "showSubstituteLightbox",
          },
        },
        [
          _vm.substituteLightboxProduct
            ? _c("div", { staticClass: "lightbox-product-details" }, [
                _c("div", { staticClass: "lightbox-product-title" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm._f("formatEntities")(
                          _vm.substituteLightboxProduct.title
                        )
                      ) +
                      " Substitutes\n      "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "description" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.substituteDescription) +
                      "\n      "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c(
                      "draggable",
                      _vm._b(
                        {
                          staticClass: "subtitute-products-drag",
                          model: {
                            value: _vm.draggableList,
                            callback: function ($$v) {
                              _vm.draggableList = $$v
                            },
                            expression: "draggableList",
                          },
                        },
                        "draggable",
                        _vm.dragOptions,
                        false
                      ),
                      _vm._l(_vm.draggableList, function (product) {
                        return _c(
                          "div",
                          { key: product.product.id, staticClass: "product" },
                          [
                            _c(
                              "div",
                              { staticClass: "product-title" },
                              [
                                _c("font-awesome-icon", {
                                  staticClass: "icon",
                                  attrs: {
                                    icon: ["fa", "grip-lines"],
                                    size: "1x",
                                    "fixed-width": "",
                                  },
                                }),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(product.product.title) +
                                    "\n            "
                                ),
                              ],
                              1
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }